import React from "react";
import download from "../../../../assets/img/card-icons/descargar.svg";
import { toSentenceCase } from "../../../../utils/capitalize";

export const TarjetaResultadosComponent = ({
  result,
  eventDownload,
  showDowload,
}) => {
  function formatDate(value) {
    value = value?.split("T")[0];
    const chunks = value.split("-");
    const format = `${chunks[2]}-${chunks[1]}-${chunks[0]}`;
    return format;
  }

  return (
    <div className={"tarjeta--activa shadow mt-2"}>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <div>
          <span className="resultado-etiqueta">Fecha de ingreso:</span>
          <span className="resultado-valor">
            {formatDate(result.feccrea)}
          </span>
        </div>
        <div>
          <span className="resultado-etiqueta">Responsable:</span>
          <span className="resultado-valor">{toSentenceCase(result.responsable)}</span>
        </div>
        <div>
          <span className="resultado-etiqueta">Especialidad:</span>
          <span className="resultado-valor">{toSentenceCase(result.especialidad)}</span>
        </div>
      </div>
      <div
        class="separador"
        style={{ width: "100%", borderTopWidth: "2px" }}
      ></div>
      <div className="iconos-acciones-tarjeta">
          <img
            src={download}
            alt="Descargar"
            onClick={() => eventDownload(result)}
          />
      </div>
    </div>
  );
};
